<template>
  <div id="updateinfo">
    <BottomBar />
    <Student v-if="components.student" v-on:dismiss="components.student = false" />
    <Login v-if="components.login" v-on:dismiss="components.login = false" />
    <ChangeMobile
      v-if="components.changeMobile"
      v-on:dismiss="components.changeMobile = false"
      v-on:complete="$toastSuccess('手机号已更改')"
    />
    <Empty v-if="!user || !user.user_id" loading="true" />
    <div class="form-wrapper" v-else>
      <div class="form">
        <div v-if="user.identity > 1" class="select-wrapper identity">
          <h2>认证身份</h2>
          <p>
            {{ $store.state.info.identity[user.identity] }}
            <i class="anyteachicon anyteach-shenfen1" />
          </p>
        </div>
        <div class="select-wrapper" id="gravatar-wrapper">
          <h2>头像</h2>
          <div class="gravatar-container">
            <div v-if="gravatar" class="img" :style="$bgd(gravatar)" @click="changeGravatar()" />
            <div v-else class="img">
              <i class="anyteachicon anyteach-user" />
            </div>
            <h1 @click="changeGravatar()">
              <span v-if="gravatar">更换头像</span>
              <span v-else>添加头像</span>
            </h1>
            <form id="uploadGravatar" enctype="multipart/form-data">
              <input
                ref="upload"
                id="gravatar"
                accept="image/png, image/gif, image/jpeg"
                type="file"
                name="gravatar"
                @change="uploadGravatar"
              />
            </form>
          </div>
        </div>
        <div class="input-wrapper">
          <h3 class="title">姓名</h3>
          <div class="input" :class="{ active: state.active === 'name' }">
            <input
              v-model="name"
              type="text"
              placeholder="您的用户名"
              @focus="state.active = 'name'"
              @blur="state.active = null"
              @input="isEdit = true"
            />
          </div>
        </div>
        <div v-if="isEdit" class="button animated fadeIn" @click="update()">保存</div>
        <div id="more">
          <div class="select-wrapper">
            <h3 @click="components.student = true">
              <i class="anyteachicon anyteach-user-graduate" />
              查看学生信息
            </h3>
          </div>
          <div class="select-wrapper">
            <h3
              v-if="user.mobile != '' && user.mobile != null"
              @click="components.changeMobile = true"
            >
              <i class="anyteachicon anyteach-phone" />
              更改手机号：
              <span>{{ user.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}</span>
            </h3>
            <h3 v-else @click="components.login = true">
              <span class="left">
                <i class="anyteachicon anyteach-phone" />
                添加手机号
              </span>
            </h3>
          </div>
          <div class="select-wrapper">
            <router-link to="/address" tag="h3">
              <i class="anyteachicon anyteach-home" />
              查看我的地址
            </router-link>
          </div>
        </div>
      </div>
      <Quote />
    </div>
  </div>
</template>
<script>
import BottomBar from "@/components/public/footer"
import Empty from "@/components/public/Empty"
import Quote from "./Quote"
import ChangeMobile from "./ChangeMobile"
// import Student from "@/components/popup/Student"
import Student from "@/components/student/Main"
import Login from "@/components/popup/Login"

export default {
  name: "Updateinfo",
  components: { BottomBar, Quote, Empty, Student, ChangeMobile, Login },
  data() {
    return {
      components: {
        student: false,
        changeMobile: false,
        login: false
      },
      isEdit: false,
      name: null,
      state: {
        active: "",
      },
    }
  },
  created() {
    this.$store.dispatch("user")
    const { query } = this.$route
    if (query.student) this.components.student = true
    if (query.change_mobile) this.components.changeMobile = true
  },
  computed: {
    user() {
      const user = this.$store.state.user
      if (user) {
        this.name = user.name
      }
      return this.$store.state.user
    },
    gravatar() {
      if (!this.user) {
        return ""
      }
      return this.user.gravatar
    },
  },
  methods: {
    changeGravatar() {
      document.getElementById("gravatar").click()
    },
    uploadGravatar(e) {
      this.$toastLoading("上传中...")
      let file = e.target.files[0]
      let data = new FormData()
      data.append("gravatar", file, file.name)
      this.$axios({
        url: window.PHP_ROOT + "/index/User/updateGravatar/",
        headers: { "Content-Type": "multipart/form-data" },
        method: "POST",
        data,
      })
        .then(({ data }) => {
          if (data.code) {
            this.$toastSuccess("头像更换成功")
            this.$store.dispatch("user")
          } else {
            this.$toastError("更换失败")
          }
        })
        .catch(err => {
          this.$toastError("更换失败")
          throw new Error(err)
        })
    },
    update() {
      if (this.name === "") {
        return this.$toast("请填写名字")
      }
      this.$axios({
        url: window.PHP_ROOT + "/index/User/userupdate/",
        data: {
          name: this.name.trim(),
        },
        method: "POST",
      })
        .then(({ data }) => {
          this.$store.dispatch("user")
          const { code } = data
          if (code == 1000) {
            this.$toast("保存成功")
            return (this.isEdit = false)
          }
          this.$toast("保存失败")
        })
        .catch(err => {
          this.$toastError("保存失败")
        })
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../static/css/public.scss";
@import "../../../static/css/prog-form.scss";
@import "../popup/modal.scss";
.unchanged {
  color: $grey !important;
}

.animated {
  animation-delay: 0s !important;
  animation-duration: 0.4s !important;
}

#updateinfo {
  background-color: white;
  width: 100%;
  padding-top: 25px;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  @include avenir();
  .gravatar-container {
    width: 100%;
    text-align: center;
    position: relative;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 10px 0;
    margin: 5px 0 0 0;
    .img {
      $diameter: 70px;
      width: $diameter;
      height: $diameter;
      margin: auto;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      i {
        font-size: 25px;
        color: $black;
        opacity: 0.7;
        margin-bottom: 10px;
      }
    }

    h1 {
      font-weight: 400;
      display: block;
      font-size: 0.8rem;
      padding: 5px 0 0 0;
      opacity: 0.6;
      @include avenir();
    }
  }

  .form {
    margin: auto;
    justify-content: space-between;
    max-width: 500px;
    padding: 0 5%;
    margin: auto;
    .select-area {
      text-align: left;
      display: flex;
      .select-wrapper {
        width: 50%;
      }
    }
    .select-wrapper {
      margin: 0 0 15px 0;
    }
    .input {
      margin-top: 5px;
    }
    .identity {
      @include avenir();
      background: #f9f9f9;
      border-radius: 3px;
      border: 1px solid #eee;
      padding: 15px 10px;
      margin: 0 auto 15px auto;
      width: 100%;
      i {
        color: $blue;
        font-size: inherit;
      }
    }

    #gravatar-wrapper {
      border-bottom: none;
      form {
        display: none;
      }
    }
  }

  .block-button {
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid $lightGrey;
    border-bottom: 1px solid $lightGrey;

    span {
      position: absolute;
    }

    .left {
      left: 25px;
    }

    .right {
      font-weight: 600;
      color: $black;
      right: 10%;
    }
  }
}

#more {
  .select-wrapper {
    &:active {
      opacity: 0.7;
    }
    .i-container {
      display: inline;
      text-align: center;
    }
    h3 {
      @include avenir-demi();
      color: $blue;
      i {
        margin: 0 5px 0 0;
      }
    }
  }
}

.button {
  width: 100%;
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 15px;
  padding: 10px;
  background: $blue;
  color: white;
  text-align: center;
  border-radius: 3px;
  &:active {
    opacity: 0.7;
  }
}

.blue {
  border-color: $blue;
  background: $blue;
  color: white !important;

  &:active {
    background-color: $blue;
  }
}
</style>
